"use strict";

define('components/document_upload',['components/document_details_edit'], function(document_details_edit) {

    // show corrupted files banner if there are files that are corrupted
    function showCorruptedFilesBanner(corruptedFiles, errorMsg) {
        var corruptedFileDiv = $('#corrupted-error-div');
        corruptedFileDiv.removeClass('hidden');
        var corrupted_error_title = corruptedFileDiv.find('.corrupted-error-msg');
        var corrupted_error_subheading = corruptedFileDiv.find('.corrupted-error-files-div');

        // Set title based on count
        corrupted_error_title.text(corruptedFiles.length + ' file' + (corruptedFiles.length === 1 ? ' is' : 's are' ) + ' corrupted');

        // Clear subheading and add the error message
        corrupted_error_subheading.empty().append($('<p></p>').text(errorMsg));

        // If multiple files, add the list
        if(corruptedFiles.length > 1) {
            corrupted_error_subheading.append($('<ul class="corrupted-error-files"></ul>'));
            corruptedFiles.forEach(function (file) {
                corrupted_error_subheading.find('ul.corrupted-error-files').append('<li>' + file + '</li>');
            });
        }
    }

    function setError(errorMsg, countSuccess, formNode, result, corruptedFiles) {
        // Hide the form, and show any errors.
        corruptedFiles = corruptedFiles || null;
        $('#upload-form').removeClass('hidden');
        $('#upload-status').addClass('hidden');

        if(corruptedFiles && corruptedFiles.length > 0) {
            showCorruptedFilesBanner(corruptedFiles, errorMsg);
        }
        else {
            var errorDiv = $('#error-div');
            errorDiv.removeClass('hidden');
            errorDiv.find('.error-msg').text(errorMsg);
        }

        // Used for excel files
        formNode.trigger('jsq:documentUploadError', [result])

        // We need to reset the progress bar, just in case the user would like to re-upload.
        var progressBar = $('#upload-status .progress-bar');
        progressBar.width("0%");

        if(countSuccess > 0) {
            setSuccess(countSuccess);
        }
    }

    function setSuccess(countSuccess) {
        $('#upload-form').removeClass('hidden');
        $('#upload-status').addClass('hidden');
        var successDiv = $('#success-div');
        successDiv.removeClass('hidden');
        successDiv.find('.success-msg').text('Successfully uploaded ' + countSuccess + ' document(s).');
    }

    function clearError() {
        $('#error-div').addClass('hidden');
        $('#success-div').addClass('hidden');
        $('#corrupted-error-div').addClass('hidden');
    }

    // Sliding window rate limiter with dynamic concurrency slots
    var rateLimiter = (function () {
        var requestsPerMinute = 600; // Limit of requests per minute
        var windowSizeInMillis = 60000; // Time window size in milliseconds
        var bufferSize = requestsPerMinute; // Size of the circular buffer
        var timestamps = new Array(bufferSize);
        var head = 0; // Points to the oldest timestamp
        var tail = 0; // Points to the next insertion point
        var count = 0; // Number of timestamps currently in the buffer
        var availableParallelReqs = 8; // Dynamic concurrency slots

        return {
            canProceed: function () {
                var now = Date.now();

                // Step 1: Remove expired timestamps
                while (count > 0 && now - timestamps[head] >= windowSizeInMillis) {
                    head = (head + 1) % bufferSize;
                    count--;
                }

                // Step 2: Check if under limit and slots are available
                if (count < requestsPerMinute && availableParallelReqs > 0) {
                    // Insert the new timestamp at the tail
                    timestamps[tail] = now;
                    tail = (tail + 1) % bufferSize;
                    count++;

                    // Consume a concurrency slot
                    availableParallelReqs--;

                    return true; // Allow the request
                }

                return false; // Deny the request
            },
            releaseSlot: function () {
                availableParallelReqs++;
            }
        };
    })();

    var documentUpload = {
        init: function(modalNode) {
            document_details_edit.init(modalNode);
            if(typeof window.__jsqRenderPillars__ === 'function') {
                window.__jsqRenderPillars__();
            }
            modalNode.on("jsq:documentUploadComplete", function( e, document_url, document_id ) {
                if (window.jsqBulkShareDocumentUploadComplete) {
                    // If we're in context of the document bulk upload pillar,
                    // we want to go back to react and return to the upload
                    // The only shared context is window
                    window.jsqBulkShareDocumentUploadComplete(document_id);
                } else {
                    // On document upload, navigate to the new document page
                    window.location = document_url;
                }
            });

            var uploadButton = modalNode.find('.modal-footer button[data-save-event="jsq:documentUpload"]');
            var createButton = modalNode.find('.modal-footer button[data-save-url]');

            $('#document-upload-single, #document-upload-member').click(function (clickEvent) {
                uploadButton.removeClass('hidden');
            });

            $('#document-upload-collection').click(function (clickEvent) {
                $('#modal-label').text('Create a new document collection');
                createButton.removeClass('hidden');
            });
        },
        uploadDocuments: function(formNode, fileList) {
            $('#upload-form').addClass('hidden');
            $('#upload-status').removeClass('hidden');

            // Upon upload, we need to hide the error div because this upload run could be a re-upload attempt by user.
            clearError();

            var progressBar = $('#upload-status .progress-bar');
            progressBar.width("0%");

            var totalBytesToUpload = 0;
            $.each(fileList, function(idx, f){
                totalBytesToUpload += f.size;
            });

            var bytesUploaded = [];
            var filesPendingUpload = fileList.length;
            var countSuccessfulUploads = 0;
            var countFailedUploads = 0;
            var corruptedFiles = [];

            // Pad the byte to upload count to the %complete calculation takes into account post-upload processing.
            var fileUploadPadding = Math.floor(totalBytesToUpload * 0.1 / filesPendingUpload);
            totalBytesToUpload += fileUploadPadding  * filesPendingUpload;

            var fileQueue = Array.from(fileList);

            function uploadNextFile() {
                if (fileQueue.length === 0) {
                    return;
                }

                // Check rate limiter
                if (!rateLimiter.canProceed()) {
                    setTimeout(uploadNextFile, 50); // Retry after 50ms if limit is hit
                    return;
                }

                var f = fileQueue.shift();
                var itemId = bytesUploaded.length;
                bytesUploaded.push(0);

                var formData = new FormData();
                formData.append('upload', f);
                formData.append('csrf_token', $('meta[name=csrf_token]').attr('content'));

                var uploadUrl = formNode.attr('action') || '/file_upload';
                var uploadCollectionId = formNode.find('input[name=collection_id]');
                if (uploadCollectionId.length == 1) {
                    uploadUrl = '/document/add/'+uploadCollectionId.val();
                    formData.append('split_pdf', formNode.find('input[name=split_pdf]').val());
                } else {
                    var uploadObjectType = formNode.find('input[name=object_type]');
                    var uploadObjectId = formNode.find('input[name=object_id]');
                    if (uploadObjectId.lengh == 1 && uploadObjectType.lengh == 1) {
                        uploadUrl = '/document/add/' + uploadObjectType.val() + '/'+uploadObjectId.val();
                    }
                }

                var updateProgressBar = function(e) {
                    if (e) {
                        bytesUploaded[itemId] = e.loaded;
                    }
                    var totalUploaded = 0;
                    $.each(bytesUploaded, function() {
                        totalUploaded += this;
                    });
                    var pc = Math.round(totalUploaded / totalBytesToUpload * 100);
                    progressBar.width(pc + "%");
                };

                $.ajax({
                    url: uploadUrl,
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    success: function(result) {
                        /* Check for errors. If error is corruption, then we wait for all the files to render a cumulative message.
                        *  Keep pushing file names until all corrupted files are found.
                        * */
                        if (result['status'] === 'error'|| result['status'] === 'corruption_error') {
                            if(result['status'] === 'corruption_error')
                                corruptedFiles.push(result['file_name']);
                            else
                                setError(result['error_message'], countSuccessfulUploads, formNode, result);
                            filesPendingUpload--;
                            countFailedUploads++;
                        } else {
                            countSuccessfulUploads++;
                            bytesUploaded[itemId] += fileUploadPadding;
                            updateProgressBar(null);
                            setSuccess(countSuccessfulUploads);
                            if (--filesPendingUpload == 0) {
                                $('.modal .btn-primary').removeClass('disabled');
                                require('components/form').resetSaveWarning(formNode);
                                if(countFailedUploads === 0) {
                                    formNode.trigger('jsq:documentUploadComplete', [result.location, result.document_id, result.data]);
                                }
                            }
                        }

                        // If all files are uploaded and there are corrupted files, show the banner
                        if(filesPendingUpload == 0 && corruptedFiles.length > 0) {
                            var error_message = corruptedFiles.length === 1 ? "The file " + corruptedFiles[0] + " appears to be corrupted. Try uploading it again or use a different file format." : "The following files appear to be corrupted. Try uploading them again or use a different file format.";
                            setError(error_message, countSuccessfulUploads, formNode, result, corruptedFiles);
                        }

                        rateLimiter.releaseSlot();
                        uploadNextFile();
                    },
                    error: function(result) {
                        countFailedUploads++;
                        bytesUploaded[itemId] += fileUploadPadding;
                        updateProgressBar(null);
                        if (result.state() === "rejected") {
                            setError('Documents could not upload because the file is invalid.', countSuccessfulUploads, formNode, result);
                            return;
                        }
                        if (--filesPendingUpload == 0) {
                            $('.modal .btn-primary').removeClass('disabled');
                            require('components/form').resetSaveWarning(formNode);
                            if (result.location && result.document_id) {
                                formNode.trigger('jsq:documentUploadComplete', [result.location, result.document_id]);
                            } else {
                                setError('Documents could not upload because of an unexpected error.', countSuccessfulUploads, formNode, result);
                            }
                        }

                        rateLimiter.releaseSlot();
                        uploadNextFile();
                    },
                    xhr: function() {
                        var xhr = $.ajaxSettings.xhr() ;
                        xhr.upload.onprogress = updateProgressBar;
                        return xhr ;
                    },
                });
            }

            // for trigerring initial 8 request
            // it does not matter if file being uploaded are less then 8
            for (var i = 0; i < 8; i++) {
                uploadNextFile();
            }
        },
    };

    return documentUpload;
});


